export default __webpack_public_path__ + "static/media/ServiceRealTime.2156e132.svg";